/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_wd_thursday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thursday`)
};

const es_age_wd_thursday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jueves`)
};

const de_age_wd_thursday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donnerstag`)
};

const nl_age_wd_thursday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Donderdag`)
};

const fr_age_wd_thursday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jeudi`)
};

const it_age_wd_thursday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giovedì`)
};

const pt_br2_age_wd_thursday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quinta-feira`)
};

const pt_age_wd_thursday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quinta-feira`)
};

const ja_age_wd_thursday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`木曜日`)
};

const zh_age_wd_thursday = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`星期四`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_wd_thursday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_wd_thursday(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_wd_thursday", locale)
	if (locale === "en") return en_age_wd_thursday(inputs)
	if (locale === "es") return es_age_wd_thursday(inputs)
	if (locale === "de") return de_age_wd_thursday(inputs)
	if (locale === "nl") return nl_age_wd_thursday(inputs)
	if (locale === "fr") return fr_age_wd_thursday(inputs)
	if (locale === "it") return it_age_wd_thursday(inputs)
	if (locale === "pt-BR") return pt_br2_age_wd_thursday(inputs)
	if (locale === "pt") return pt_age_wd_thursday(inputs)
	if (locale === "ja") return ja_age_wd_thursday(inputs)
	return zh_age_wd_thursday(inputs)
};